import styles from "./listing-card-loading.module.css";

export default function ListingCardLoading({
  activePlan,
}: {
  activePlan: string;
}) {
  return (
    <div
      className={`${styles.listingMock} ${styles[activePlan]} ${
        activePlan === "spotlight" ? styles.spotlight : ""
      }`}
    >
      <div className={`${styles.listingPhoto} ${styles.isLoading}`}></div>
      <div className={styles.content}>
        <div className={styles.mainContent}>
          {(activePlan === "prime" || activePlan === "spotlight") && (
            <div className={`${styles.title} ${styles.isLoading}`}></div>
          )}
          {(activePlan === "essential" || activePlan === "plus") && (
            <div className={styles.titleWrapper}>
              <div className={`${styles.title1} ${styles.isLoading}`}></div>
              {/* <div className={`${styles.title2} ${styles.isLoading}`}></div> */}
            </div>
          )}
          <div className={styles.description}>
            <div
              className={`${styles.descriptionLine1} ${styles.isLoading}`}
            ></div>
            <div
              className={`${styles.descriptionLine2} ${styles.isLoading}`}
            ></div>
            <div
              className={`${styles.descriptionLine3} ${styles.isLoading}`}
            ></div>
          </div>
          {(activePlan === "prime" || activePlan === "spotlight") && (
            <div className={styles.features}>
              <div className={`${styles.feature} ${styles.isLoading}`}></div>
              <div className={styles.featureSeparator}></div>
              <div className={`${styles.feature} ${styles.isLoading}`}></div>
              <div className={styles.featureSeparator}></div>
              <div className={`${styles.feature} ${styles.isLoading}`}></div>
              <div className={styles.featureSeparator}></div>
              <div className={`${styles.feature} ${styles.isLoading}`}></div>
              <div className={styles.featureSeparator}></div>
              <div className={`${styles.feature} ${styles.isLoading}`}></div>
            </div>
          )}
          {(activePlan === "essential" || activePlan === "plus") && (
            <div className={styles.featuresSimple}>
              <div className={styles.featuresRow}>
                <div className={`${styles.feature} ${styles.isLoading}`}></div>
                <div className={styles.featureSeparator}></div>
                <div className={`${styles.feature} ${styles.isLoading}`}></div>
              </div>
              <div className={styles.featuresRow}>
                <div className={`${styles.feature} ${styles.isLoading}`}></div>
                <div className={styles.featureSeparator}></div>
                <div className={`${styles.feature} ${styles.isLoading}`}></div>
              </div>
            </div>
          )}
          <div className={`${styles.address} ${styles.isLoading}`}></div>
          {(activePlan === "plus" ||
            activePlan === "prime" ||
            activePlan === "spotlight") && (
            <>
              <div className={`${styles.price} ${styles.isLoading}`}></div>
              <div className={styles.actions}>
                <div className={styles.userData}>
                  <div className={`${styles.image} ${styles.isLoading}`}></div>

                  <div
                    className={`${styles.userName} ${styles.isLoading}`}
                  ></div>
                </div>
                <div className={styles.buttonsWrapper}>
                  <div
                    className={`${styles.roundButton} ${styles.isLoading}`}
                  ></div>

                  <div
                    className={`${styles.roundButton} ${styles.isLoading}`}
                  ></div>
                </div>
              </div>
            </>
          )}
        </div>
        {activePlan === "essential" && (
          <div className={styles.actions}>
            <div className={`${styles.price} ${styles.isLoading}`}></div>

            <div className={styles.buttonsWrapper}>
              <div
                className={`${styles.roundButton} ${styles.isLoading}`}
              ></div>

              <div
                className={`${styles.roundButton} ${styles.isLoading}`}
              ></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
